<script lang="ts">
  import SharepointFileInput from "../../components/SharepointFileInput.svelte";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";

  let {
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors,
  }: {
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    errors: { [key: string]: string } | undefined;
  } = $props();
</script>

<h2 class="ui-title">Upload booking confirmation</h2>

<fieldset class="ui-fieldset">
  <legend class="mb-6 pb-0">
    Please upload your easyJet booking confirmation. You'll usually find this in an email from easyJet.
  </legend>
  <div>
    <p class="ui-alert ui-alert-info block pb-4 -mb-2.5 mt-0">
      Your name, booking email address, booking reference, and travel dates should be clearly visible.
      <b>A&nbsp;screenshot of your email works well.</b>
    </p>
    <SharepointFileInput
      name="booking_confirmation"
      accept={uploadAttachmentExtensions}
      {createUploadSessionUrl}
      multiple
      required
    />
  </div>
</fieldset>

{#if errors?.document_missing}<div class="ui-error">{errors.document_missing}</div>{/if}

<FooterButtons>
  <ContinueButton type="submit" label="Done" />
</FooterButtons>
